import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../Store";
import { useMediaQuery, useTheme } from "@mui/system";
import { CalendarCheck } from 'lucide-react';

type Dayjs = dayjs.Dayjs;

interface CustomDatePickerProps {
  value: Dayjs | null;
  onChange: (newValue: Dayjs | null, formattedDate: string) => void;
  placeholder?: string;
  disablePast?: boolean;
  fontFamily?: string;
  backgroundColor?: string;
  disableFuture?: boolean;
  format?: string;
}

function CustomDatePicker({
  placeholder,
  value,
  onChange,
  disablePast = false,
  disableFuture = false,
  backgroundColor = "white",
  fontFamily = "montserrat-Regular",
  format = "DD/MM/YYYY",
}: CustomDatePickerProps) {
  const handleDateChange = (newValue: Dayjs | null) => {
    const formattedDate = newValue ? newValue.format("YYYY-MM-DD") : "";
    onChange(newValue, formattedDate);
  };
const theme = useTheme();
  const screen_1024 = useMediaQuery(theme.breakpoints.up(1025));
  const selector = useSelector((state: RootState) => state.mainApp);

  useEffect(() => {}, [selector.lang]);

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DatePicker
        value={value}
        onChange={handleDateChange}
        disablePast={disablePast}
        disableFuture={disableFuture}
        format={format}
        maxDate={dayjs().subtract(10, "year")}
        slots={{
          openPickerIcon: CalendarCheck, // ✅ Your custom icon
        }}
        // slotProps={{
        //   textField: {
        //     placeholder: placeholder,

        //     sx: {
        //       backgroundColor: backgroundColor,
        //       width: "100%",
        //       borderRadius: "16px",
        //       border: "none",
        //       fontFamily:`montserrat-Regular`,
        //       height: 56,
        //       "& .MuiInputBase-input": {
        //         padding: "18px 16px",
        //         "::placeholder": {
        //           color: "#7c7c7c",
        //           opacity: 2,
        //           fontFamily:`montserrat-Regular`
        //         },
        //         fontFamily:`montserrat-Regular`

        //       },
        //       "& fieldset": {
        //         display: "none",
        //       },
        //       "& .MuiFormLabel-root": {
        //         display: "none",
        //       },
        //     },
        //   },
        // }}
       slotProps={{
  textField: {
    inputProps: {
      placeholder: "JJ/MM/AAAA",
    },
    sx: {
      backgroundColor: backgroundColor,
      width: "100%",
      borderRadius: "16px",

      border: "none",
      fontFamily: "montserrat-Regular",
        height : screen_1024 ? "56px" : "48px",
      "& .MuiInputBase-input": {
        
        padding: "18px 16px",
        fontFamily: "montserrat-Regular",
        "&::placeholder": {
          color: "#7c7c7c",
          opacity: 1,
        },
        "&:focus::placeholder": {
          color: "transparent",
        },
      },
      "& fieldset": {
        display: "none",
      },
      "& .MuiFormLabel-root": {
        display: "none",
      },
    },
  },
}}

      />
    </LocalizationProvider>
  );
}

export default CustomDatePicker;
